const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

/**
 * Crear registro de recepción de ropa de cliente
 */
export const createRecepcionRopaCliente = async (data) => {
  try {
    const response = await fetch(`${API_URL}/recepcion-ropa-clientes/create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al crear recepción');
    }
    return await response.json();
  } catch (error) {
    console.error('Error en createRecepcionRopaCliente:', error);
    throw error;
  }
};

/**
 * Obtener registros con filtros y paginación
 */
export const fetchRecepcionesRopaClientes = async (filters = {}) => {
  try {
    const { query = {}, page = 1, limit = 20 } = filters;
    const response = await fetch(`${API_URL}/recepcion-ropa-clientes/filter`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query, page, limit }),
    });
    if (!response.ok) throw new Error('Error al obtener registros');
    const result = await response.json();
    return {
      data: result.data || [],
      totalRecords: result.totalRecords || 0,
      totalPages: result.totalPages || 0,
      currentPage: result.currentPage || page,
    };
  } catch (error) {
    console.error('Error en fetchRecepcionesRopaClientes:', error);
    throw error;
  }
};

/**
 * Obtener registro por ID
 */
export const fetchRecepcionRopaClienteById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/recepcion-ropa-clientes/${id}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) throw new Error('Error al obtener registro');
    return await response.json();
  } catch (error) {
    console.error('Error en fetchRecepcionRopaClienteById:', error);
    throw error;
  }
};

/**
 * Obtener recepciones por cliente
 */
export const fetchRecepcionesByCliente = async (clienteId, limit = 20, page = 1) => {
  try {
    const response = await fetch(`${API_URL}/recepcion-ropa-clientes/cliente/${clienteId}?limit=${limit}&page=${page}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) throw new Error('Error al obtener registros del cliente');
    const result = await response.json();
    return {
      data: result.data || [],
      totalRecords: result.totalRecords || 0,
      totalPages: result.totalPages || 0,
      currentPage: result.currentPage || page,
    };
  } catch (error) {
    console.error('Error en fetchRecepcionesByCliente:', error);
    throw error;
  }
};
